import Vue from 'vue'
import Router from 'vue-router'
import Orders from '../views/Orders'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'orders',
      component: Orders,
      meta: {
        title: 'Orders'
      }
    },
    {
      path: '/piggybank',
      name: 'piggybank',
      component: () => import('../views/Piggybank'),
      meta: {
        title: 'Piggybank'
      }
    }
  ]
})
